import DispatcherEvent from '@carvana/merch-native/DispatcherEvent';
import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useIsNative } from '~/context/common/DeviceContext';
import { useSendMessageToNative } from '~/context/common/NativeContext';
import { useUserLocation } from '~/context/common/UserContext';

export default function useUpdateGeolocationDispatcher() {
  const isNative = useIsNative();
  const sendMessageToNative =
    useSendMessageToNative<DispatcherEvent.UpdateGeolocation>();
  const { city, state, zip } = useUserLocation();

  useSubsequentEffect(() => {
    if (!isNative) return;

    sendMessageToNative(DispatcherEvent.UpdateGeolocation, {
      city,
      state,
      zip
    });
  }, [city, isNative, sendMessageToNative, state, zip]);
}
